import { heicTo } from 'heic-to'
import truncate from 'lodash.truncate'
import path from 'path'
import Dropdown from 'rc-dropdown'
import 'rc-dropdown/assets/index.css'
import { useEffect, useState } from 'react'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'

import { useMenuState } from 'src/providers/MenuStateProvider'

import { Button } from 'src/components/atoms/Button'
import { DefaultAvatar } from 'src/components/atoms/Icons/DefaultAvatar'

import useMediaQuery from 'src/hooks/useMediaQuery'
import { getDefaultAvatar } from 'src/utils/avatar'

import { AccountMenu } from './AccountMenu'

export const AccountDropdown = ({
  avatarPath,
  accountName
}: {
  avatarPath?: string
  accountName?: string
}) => {
  const isMobile = useMediaQuery('(max-width: 1024px)')
  const { isOpen, setIsOpen } = useMenuState()

  useEffect(() => {
    if (isMobile) {
      setIsOpen(false)
    }
  }, [isMobile, setIsOpen])

  const [backgroundImage, setBackgroundImage] = useState<string>('')

  useEffect(() => {
    const getAvatarImageUrl = async () => {
      const avatarUrl = getDefaultAvatar(accountName || '', avatarPath)
      const extension = path.extname(avatarUrl)
      if (!extension.toLowerCase().startsWith('.heic')) {
        setBackgroundImage(avatarUrl)
        return
      }
      try {
        const response = await fetch(avatarUrl)
        const blob = await response.blob()

        const convertedBlob = await heicTo({
          blob,
          type: 'image/jpeg',
          quality: 1
        })

        const objectUrl = URL.createObjectURL(convertedBlob as Blob)
        setBackgroundImage(objectUrl)
      } catch (error) {
        setBackgroundImage(getDefaultAvatar(accountName || '', null))
      }
    }
    getAvatarImageUrl()
  }, [accountName, avatarPath])

  return (
    <Dropdown
      onVisibleChange={v => {
        if (!isMobile) setIsOpen(v)
      }}
      placement='bottomRight'
      visible={isOpen}
      trigger='click'
      overlay={<AccountMenu />}
    >
      <div>
        <Button
          size='large'
          color='white'
          variant='outlined'
          className='font-semibold focus:shadow-none h-11'
        >
          <div className='flex flex-row items-center gap-[8px]'>
            {avatarPath ? (
              <div
                className='bg-contain rounded-full overflow-hidden relative w-[30px] h-[30px] ml-[-12px]'
                style={{
                  backgroundImage: `url(${backgroundImage})`
                }}
              />
            ) : (
              <DefaultAvatar className='w-[30px] h-[30px] ml-[-12px] rounded-full text-white bg-mostlyGreen' />
            )}

            <span>{truncate(accountName || 'Account', { length: 15 })}</span>
            {isOpen ? (
              <MdKeyboardArrowUp size='20px' />
            ) : (
              <MdKeyboardArrowDown size='20px' />
            )}
          </div>
        </Button>
      </div>
    </Dropdown>
  )
}
